import { Pipe, PipeTransform } from '@angular/core';
import { PlessViewUtilsSub } from '../commons/kymw00/pless-view-utils-sub.service';

/**
 * 数値をカンマ区切りの文字列に変換するパイプクラス
 */
@Pipe({name: 'comma'})
export class CommaPipe implements PipeTransform {
  transform(value: number | string): string {
    if (value || 0 === value) {
      return PlessViewUtilsSub.editPriceComma(value, true);
    } else {
      return '';
    }
  }
}
